import requests from "./httpService";

const VehicleModelServices = {
  getAllVehicleModel: async (body) => {
    return requests.get(`/vehiclename/`);
  },

  addVehicleModel: async (body) => {
    return requests.post(`/vehiclename/add`, body);
  },
  getVehicleModelById: async (id) => {

    return requests.get(`/vehiclename/${id}`);
  },
  updateVehicleModel: async (id, body) => {
    return requests.put(`/vehiclename/update/${id}`, body);
  },

  deleteVehicleModel: async (id, body) => {
    return requests.delete(`/vehiclename/delete/${id}`, body);
  },
};

export default VehicleModelServices;
